import { NIN_HERO_DEMO_SRC, NINXL_HERO_DEMO_SRC } from '@/lib/landing-demos'
import { isCmsMediaUrl } from './content'
import type { CmsLandingHeroPageKey, LandingHeroDemoDto } from './types'

export type { CmsLandingHeroPageKey, LandingHeroDemoDto }

/** baby: code registry fallback when CMS has no published hero video yet */
export function getLandingHeroFallbackSrc(pageKey: CmsLandingHeroPageKey): string {
  return pageKey === 'nin' ? NIN_HERO_DEMO_SRC : NINXL_HERO_DEMO_SRC
}

export async function fetchLandingHeroDemo(
  pageKey: CmsLandingHeroPageKey,
): Promise<LandingHeroDemoDto> {
  try {
    const response = await fetch(`/api/cms/landing-hero?page=${pageKey}`, {
      cache: 'no-store',
    })
    if (!response.ok) {
      return { pageKey, demoUrl: null, posterUrl: null }
    }
    const payload = (await response.json()) as LandingHeroDemoDto
    return {
      pageKey,
      demoUrl: isCmsMediaUrl(payload.demoUrl) ? payload.demoUrl : null,
      posterUrl: isCmsMediaUrl(payload.posterUrl) ? payload.posterUrl : null,
    }
  } catch {
    return { pageKey, demoUrl: null, posterUrl: null }
  }
}

/** baby: CMS video when published, otherwise the hardcoded Blob fallback */
export async function fetchLandingHeroDemoSrc(
  pageKey: CmsLandingHeroPageKey,
): Promise<string> {
  const demo = await fetchLandingHeroDemo(pageKey)
  return demo.demoUrl ?? getLandingHeroFallbackSrc(pageKey)
}
